import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Fade, IconButton, Link, Menu, MenuItem, Stack, } from '@mui/material';
import { ExpandLess as ExpandIcon, ExpandMore as MinimizeIcon, Close as CloseIcon, Menu as MenuIcon, } from '@mui/icons-material';
import Image from './Image';
import { getDefaultConverseOrigin } from '../defaultClientAIUrls';
// import assetGetData from '../common/asset/assetGetData';
const MINIMIZED_HEADER_FALLBACK_HEIGHT_PX = 40;
const EmbeddedHeader = ({ amplifyEnvironment, logoAsset, minimizedLogoAsset, logoPosition, minimized, menuButtonPosition, minimizeButtonPosition, closeButtonPosition, headerSx, headerHeight, minimizedHeight, resetConversationLabel, triggerReset, headerControlsColor, hamburgerMenu, customWelcomeEnabled = false, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const handleTriggerReset = () => {
        triggerReset();
        handleCloseMenu();
    };
    const numericHeaderHeight = Number.isFinite(headerHeight) ? headerHeight : 0;
    const normalizedMinimizedHeight = Number.isFinite(minimizedHeight) ? Number(minimizedHeight) : 0;
    const effectiveMinimizedHeight = Math.max(normalizedMinimizedHeight, 
    // The opted-in expanded header must not enlarge the host-provided launcher.
    customWelcomeEnabled ? 0 : numericHeaderHeight, MINIMIZED_HEADER_FALLBACK_HEIGHT_PX);
    const resolvedHeaderImageMaxHeight = minimized ? effectiveMinimizedHeight : Math.max(numericHeaderHeight, 0);
    const handleMinimize = () => {
        window?.top?.postMessage({
            source: 'microcommerce-ai-embed',
            type: minimized ? 'expandWindow' : 'minimizeWindow',
        }, '*');
    };
    const headerButtons = (position) => (_jsx(Fade, { in: !minimized, style: { display: minimized ? 'none' : 'flex' }, children: _jsxs(Stack, { direction: "row", alignContent: "center", children: [menuButtonPosition === position && (_jsxs(_Fragment, { children: [_jsx(IconButton, { id: "conversations-menu-button", onClick: (event) => handleMenuClick(event), sx: { color: headerControlsColor }, children: _jsx(MenuIcon, {}) }), _jsx(Menu, { id: "conversations-menu", anchorEl: anchorEl, open: menuOpen, onClose: handleCloseMenu, MenuListProps: {
                                'aria-labelledby': 'basic-button',
                            }, sx: { color: headerControlsColor }, children: (() => {
                                const items = hamburgerMenu?.items;
                                if (Array.isArray(items) && items.length > 0) {
                                    return items.map((item, i) => {
                                        if (item.type === 'newConversation') {
                                            return item.enabled !== false
                                                ? (_jsx(MenuItem, { onClick: handleTriggerReset, children: resetConversationLabel }, "new-conversation"))
                                                : null;
                                        }
                                        const url = item.url?.trim();
                                        if (!url)
                                            return null;
                                        return (_jsx(MenuItem, { component: Link, href: url, target: "_blank", rel: "noopener noreferrer", sx: { textDecoration: 'none', color: 'inherit' }, onClick: handleCloseMenu, children: item.title?.trim() || url }, item.id || `link-${i}`));
                                    });
                                }
                                return [
                                    (((hamburgerMenu?.enableNewConversation !== false) || !hamburgerMenu) && (_jsx(MenuItem, { onClick: handleTriggerReset, children: resetConversationLabel }, "new-conversation"))),
                                    ...(hamburgerMenu?.links
                                        ?.filter((link) => link.url?.trim())
                                        ?.map((link, i) => (_jsx(MenuItem, { component: Link, href: link.url, target: "_blank", rel: "noopener noreferrer", sx: { textDecoration: 'none', color: 'inherit' }, onClick: handleCloseMenu, children: link.title?.trim() || link.url }, `link-${i}-${link.url}`))) ?? []),
                                ].filter(Boolean);
                            })() })] })), minimizeButtonPosition === position && (_jsx(IconButton, { onClick: handleMinimize, sx: { color: headerControlsColor }, children: minimized ? _jsx(ExpandIcon, {}) : _jsx(MinimizeIcon, {}) })), closeButtonPosition === position && (_jsx(IconButton, { onClick: () => {
                        window?.top?.postMessage({ source: 'microcommerce-ai-embed', type: 'closeWindow' }, '*');
                    }, sx: { color: headerControlsColor }, children: _jsx(CloseIcon, {}) }))] }) }));
    const headerTitle = (position) => {
        const centerMinimizedLogo = customWelcomeEnabled && minimized;
        const image = minimized ? minimizedLogoAsset : logoAsset;
        const converseOrigin = getDefaultConverseOrigin(amplifyEnvironment);
        const imageUrl = image?.url ||
            (minimized
                ? `${converseOrigin}/embed/static/ask_button.png`
                : `${converseOrigin}/embed/static/ask_header.png`);
        return (_jsx(Stack, { direction: "row", sx: position === 'left' && !centerMinimizedLogo ? {
                position: 'absolute',
                left: headerSx.padding,
                top: '50%',
                transform: 'translate(0, -50%)',
                cursor: minimized ? 'pointer' : 'unset',
                alignItems: 'center',
            } : {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                cursor: minimized ? 'pointer' : 'unset',
                alignItems: 'center',
            }, children: (centerMinimizedLogo ? position === 'center' : logoPosition === position) && (_jsx(Image, { url: imageUrl, status: image?.status ?? '', alt: image?.alt ?? '', className: image?.className, avatar: image?.avatar, avatarVariant: image?.avatarVariant, customStyle: { backgroundColor: 'inherit', ...(customWelcomeEnabled ? image?.customStyle : {}), maxHeight: `${resolvedHeaderImageMaxHeight}px` }, backgroundColor: "inherit" })) }));
    };
    return (_jsxs(Stack, { onClick: () => {
            if (minimized) {
                handleMinimize();
            }
        }, sx: {
            ...headerSx,
            ...(minimized ? {
                minHeight: `${effectiveMinimizedHeight}px`,
                height: `${effectiveMinimizedHeight}px`,
            } : {}),
        }, direction: "row", children: [headerButtons('left'), headerTitle('left'), _jsx(Box, { sx: { flexGrow: 1 } }), headerTitle('center'), _jsx(Box, { sx: { flexGrow: 1 } }), headerButtons('right')] }));
};
EmbeddedHeader.defaultProps = {
    logoAsset: undefined,
    minimizedLogoAsset: undefined,
};
export default EmbeddedHeader;
//# sourceMappingURL=EmbeddedHeader.js.map